import React from 'react';
import lazyload from '@src/utils/lazyload';
import { themeDepLibrary } from '@src/utils/constants';
var Color = lazyload(function () {
  return import('./base/color');
});
var Border = lazyload(function () {
  return import('./base/border');
});
var Font = lazyload(function () {
  return import('./base/font');
});
var Icon = lazyload(function () {
  return import('./base/icon');
});
var Shadow = lazyload(function () {
  return import('./base/shadow');
});
var Size = lazyload(function () {
  return import('./base/size');
});
var disabledVue = window.themeConfig.depLibrary === themeDepLibrary['vue'];
export default {
  base: {
    icon: /*#__PURE__*/React.createElement("svg", {
      className: "arco-icon",
      viewBox: "0 0 16 16",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M5.66669 2H2.66669C2.1144 2 1.66669 2.44772 1.66669 3V13C1.66669 13.5523 2.1144 14 2.66669 14H5.66669C6.21897 14 6.66669 13.5523 6.66669 13V3C6.66669 2.44772 6.21897 2 5.66669 2Z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 2H13.3333C13.8856 2 14.3333 2.44772 14.3333 3V6C14.3333 6.55228 13.8856 7 13.3333 7H10C9.44772 7 9 6.55228 9 6V3C9 2.44772 9.44772 2 10 2Z",
      fill: "currentColor"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 9H13.3333C13.8856 9 14.3333 9.44772 14.3333 10V13C14.3333 13.5523 13.8856 14 13.3333 14H10C9.44772 14 9 13.5523 9 13V10C9 9.44772 9.44772 9 10 9Z",
      fill: "currentColor"
    })),
    title: '基础样式',
    i18Key: 'routes.basic-style',
    items: [{
      name: '颜色 Color',
      key: 'Color',
      component: Color,
      i18Key: 'routes.basic-style.color'
    }, {
      name: '字体 Font',
      key: 'Font',
      component: Font,
      i18Key: 'routes.basic-style.font'
    }, {
      name: '边框 Border',
      key: 'Border',
      component: Border,
      i18Key: 'routes.basic-style.border'
    }, {
      name: '阴影 Shadow',
      key: 'Shadow',
      component: Shadow,
      i18Key: 'routes.basic-style.shadow'
    }, {
      name: '尺寸 Size',
      key: 'Size',
      component: Size,
      i18Key: 'routes.basic-style.size'
    }, {
      name: '图标 Icon',
      key: 'Icon',
      component: Icon,
      i18Key: 'routes.basic-style.icon'
    }, {
      name: 'IconHover',
      key: 'IconHover',
      i18Key: 'routes.basic-style.hover-icon'
    }]
  },
  components: {
    icon: /*#__PURE__*/React.createElement("svg", {
      className: "arco-icon",
      viewBox: "0 0 16 16",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2 2.63107C15.2 2.01742 14.7025 1.51996 14.0889 1.51996H1.9111C1.29745 1.51996 0.799988 2.01742 0.799988 2.63107V13.3688C0.799988 13.9825 1.29745 14.48 1.9111 14.48H14.0889C14.7025 14.48 15.2 13.9825 15.2 13.3688V2.63107ZM7.84063 4.46741C7.86728 4.27009 8.04442 4.13025 8.23992 4.15221L8.88355 4.22448C9.08263 4.24683 9.22611 4.42835 9.20403 4.62991L9.2029 4.6392L8.27073 11.5403C8.24408 11.7377 8.06694 11.8775 7.87144 11.8556L7.22781 11.7833C7.02874 11.7609 6.88525 11.5794 6.90733 11.3778L6.90846 11.3686L7.84063 4.46741ZM4.98821 5.97989C5.12598 5.83949 5.34886 5.83491 5.49215 5.96953L5.94711 6.39696C6.09394 6.5349 6.10252 6.76724 5.95972 6.92287L4.70849 8.21832L5.95972 9.51375C6.09976 9.65874 6.0972 9.89123 5.94711 10.0397L5.49215 10.4671C5.34886 10.6017 5.12598 10.5971 4.98821 10.4567L3.04553 8.47713C2.90499 8.33392 2.90499 8.10271 3.04553 7.9595L4.98821 5.97989ZM11.009 5.97989C10.8712 5.83949 10.6483 5.83491 10.5051 5.96953L10.0501 6.39696C9.90001 6.5454 9.89745 6.77788 10.0375 6.92287L11.2887 8.21832L10.0375 9.51375L10.0309 9.52073C9.89469 9.66939 9.90327 9.90173 10.0501 10.0397L10.5051 10.4671C10.6483 10.6017 10.8712 10.5971 11.009 10.4567L12.9517 8.47713C13.0922 8.33392 13.0922 8.10271 12.9517 7.9595L11.009 5.97989Z",
      fill: "currentColor"
    })),
    title: '组件',
    i18Key: 'routes.components',
    items: [{
      title: '通用',
      i18Key: 'routes.general',
      items: [{
        name: '按钮 Button',
        key: 'Button',
        i18Key: 'routes.button'
      }, {
        name: '链接 Link',
        key: 'Link',
        i18Key: 'routes.link'
      }, {
        name: '排版 Typography',
        key: 'Typography',
        i18Key: 'routes.typography'
      }]
    }, {
      title: '布局',
      i18Key: 'routes._layout',
      items: [{
        name: '分割线 Divider',
        key: 'Divider',
        i18Key: 'routes.divider'
      }]
    }, {
      title: '数据展示',
      i18Key: 'routes.data-show',
      items: [{
        name: '头像 Avatar',
        key: 'Avatar',
        i18Key: 'routes.avatar'
      }, {
        name: '徽标 Badge',
        key: 'Badge',
        i18Key: 'routes.badge'
      }, {
        name: '卡片 Card',
        key: 'Card',
        i18Key: 'routes.card'
      }, {
        name: '日历 Calendar',
        key: 'Calendar',
        i18Key: 'routes.calendar',
        disabled: disabledVue
      }, {
        name: '折叠面板 Collapse',
        key: 'Collapse',
        i18Key: 'routes.collapse'
      }, {
        name: '评论 Comment',
        key: 'Comment',
        i18Key: 'routes.comment'
      }, {
        name: '描述列表 Descriptions',
        key: 'Descriptions',
        i18Key: 'routes.descriptions'
      }, {
        name: '空状态 Empty',
        key: 'Empty',
        i18Key: 'routes.empty'
      }, {
        name: '图片 Image',
        key: 'Image',
        disabled: disabledVue,
        i18Key: 'routes.image'
      }, {
        name: '列表 List',
        key: 'List',
        i18Key: 'routes.list'
      }, {
        name: '气泡卡片 Popover',
        key: 'Popover',
        i18Key: 'routes.popover'
      }, {
        name: '数值显示 Statistic',
        key: 'Statistic',
        i18Key: 'routes.statistic'
      }, {
        name: '表格 Table',
        key: 'Table',
        i18Key: 'routes.table'
      }, {
        name: '标签页 Tabs',
        key: 'Tabs',
        i18Key: 'routes.tabs'
      }, {
        name: '标签 Tag',
        key: 'Tag',
        i18Key: 'routes.tag'
      }, {
        name: '时间轴 Timeline',
        key: 'Timeline',
        i18Key: 'routes.timeline'
      }, {
        name: '文字气泡 Tooltip',
        key: 'Tooltip',
        i18Key: 'routes.tooltip'
      }, {
        name: '树 Tree',
        key: 'Tree',
        i18Key: 'routes.tree'
      }]
    }, {
      title: '数据输入',
      i18Key: 'routes.data-input',
      items: [{
        name: '自动完成 AutoComplete',
        key: 'AutoComplete',
        i18Key: 'routes.auto-complete'
      }, {
        name: '级联选择 Cascader',
        key: 'Cascader',
        i18Key: 'routes.cascader'
      }, {
        name: '复选框 Checkbox',
        key: 'Checkbox',
        i18Key: 'routes.checkbox'
      }, {
        name: '颜色选择器 ColorPicker',
        key: 'ColorPicker',
        disabled: disabledVue,
        i18Key: 'routes.color-picker'
      }, {
        name: '日期选择器 DatePicker',
        key: 'DatePicker',
        i18Key: 'routes.date-picker'
      }, {
        name: '表单 Form',
        key: 'Form',
        i18Key: 'routes.form'
      }, {
        name: '输入框 Input',
        key: 'Input',
        i18Key: 'routes.input'
      }, {
        name: '数字输入框 InputNumber',
        key: 'InputNumber',
        i18Key: 'routes.input-number'
      }, {
        name: '验证码输入 VerificationCode',
        key: 'VerificationCode',
        disabled: disabledVue,
        i18Key: 'routes.verification-code'
      }, {
        name: '标签输入框 InputTag',
        key: 'InputTag',
        i18Key: 'routes.input-tag'
      }, {
        name: '评分 Rate',
        key: 'Rate',
        i18Key: 'routes.rate'
      }, {
        name: '单选框 Radio',
        key: 'Radio',
        i18Key: 'routes.radio'
      }, {
        name: '选择器 Select',
        key: 'Select',
        i18Key: 'routes.select'
      }, {
        name: '滑动输入条 Slider',
        key: 'Slider',
        i18Key: 'routes.slider'
      }, {
        name: '开关 Switch',
        key: 'Switch',
        i18Key: 'routes.switch'
      }, {
        name: '穿梭框 Transfer',
        key: 'Transfer',
        i18Key: 'routes.transfer'
      }, {
        name: '时间选择器 TimePicker',
        key: 'TimePicker',
        i18Key: 'routes.time-picker'
      }, {
        name: '树选择 TreeSelect',
        key: 'TreeSelect',
        i18Key: 'routes.tree-select'
      }, {
        name: '上传 Upload',
        key: 'Upload',
        i18Key: 'routes.upload'
      }]
    }, {
      title: '反馈',
      i18Key: 'routes.feedback',
      items: [{
        name: '警告提示 Alert',
        key: 'Alert',
        i18Key: 'routes.alert'
      }, {
        name: '抽屉 Drawer',
        key: 'Drawer',
        i18Key: 'routes.drawer'
      }, {
        name: '全局提示 Message',
        key: 'Message',
        i18Key: 'routes.message'
      }, {
        name: '对话框 Modal',
        key: 'Modal',
        i18Key: 'routes.modal'
      }, {
        name: '通知提醒框 Notification',
        key: 'Notification',
        disabled: disabledVue,
        i18Key: 'routes.notification'
      }, {
        name: '气泡确认框 Popconfirm',
        key: 'Popconfirm',
        i18Key: 'routes.popconfirm'
      }, {
        name: '进度条 Progress',
        key: 'Progress',
        i18Key: 'routes.progress'
      }, {
        name: '结果页 Result',
        key: 'Result',
        i18Key: 'routes.result'
      }, {
        name: '加载中 Spin',
        key: 'Spin',
        i18Key: 'routes.spin'
      }, {
        name: '骨架屏 Skeleton',
        key: 'Skeleton',
        i18Key: 'routes.skeleton'
      }, {
        name: '水印 Watermark',
        key: 'Watermark',
        disabled: disabledVue,
        i18Key: 'routes.watermark'
      }]
    }, {
      title: '导航',
      i18Key: 'routes.nav',
      items: [{
        name: '锚点 Anchor',
        key: 'Anchor',
        i18Key: 'routes.anchor'
      }, {
        name: '面包屑 Breadcrumb',
        key: 'Breadcrumb',
        i18Key: 'routes.breadcrumb'
      }, {
        name: '下拉菜单 Dropdown',
        key: 'Dropdown',
        i18Key: 'routes.dropdown'
      }, {
        name: '菜单 Menu',
        key: 'Menu',
        i18Key: 'routes.menu'
      }, {
        name: '页头 PageHeader',
        key: 'PageHeader',
        i18Key: 'routes.page-header'
      }, {
        name: '分页 Pagination',
        key: 'Pagination',
        i18Key: 'routes.pagination'
      }, {
        name: '步骤条 Steps',
        key: 'Steps',
        i18Key: 'routes.steps'
      }]
    }, {
      title: '其他',
      i18Key: 'routes.other',
      items: [{
        name: '伸缩框 ResizeBox',
        key: 'ResizeBox',
        disabled: disabledVue,
        i18Key: 'routes.resize-box'
      }]
    }]
  }
};